import { CategoryItem } from '@/types'
import Container from './Container'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import { Entries, Entry, EntryImage } from './CategoryEntry.styles'
import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { useRouter } from 'next/router'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { useTileClick } from '@/hooks/HTMLElementClickHook'

const CategoryGrid: React.FC<{ categories: CategoryItem[]; label: string }> = ({ categories, label }) => {
  const defaultProperties = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)
  const router = useRouter()
  const lang = router.query.lang
  const trackTileClicked = useTileClick('Featured Links')

  return (
    <div data-mcp-id="category-grid">
      <div style={{ background: 'var(--brand-primary)' }}>
        <Container>
          <Heading size="XL" spacing={false}>
            {label}
          </Heading>
          <Spacing size="XL" />
          <Entries>
            {categories?.map(({ link, image, name }, index) => (
              <Entry
                key={link}
                href={`${baseUrl}${lang}/things-to-do/${link}`}
                onClick={(event) => {
                  trackTileClicked({
                    tileTitle: name,
                    url: `${baseUrl}${lang}/things-to-do/${link}`,
                    position: index + 1,
                    sectionTitle: label,
                    imageUrl: image,
                    event,
                  })
                }}
              >
                <LazyLoadComponent>
                  <EntryImage image={image} height="200px" />
                </LazyLoadComponent>
                <Heading size="S" bold={false} spacing={false}>
                  {name}
                </Heading>
              </Entry>
            ))}
          </Entries>
        </Container>
      </div>
    </div>
  )
}

export default CategoryGrid
